<script setup lang="ts">
// globals
defineProps({
  center: {
    type: Boolean,
    default: false,
  },
  colorHeader: {
    type: Boolean,
    default: false,
  },
  dividers: {
    type: Boolean,
    default: false,
  },
  fillHeight: {
    type: Boolean,
    default: false,
  },
  flat: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  loadingText: {
    type: String,
    default: '',
  },
  noPadding: {
    type: Boolean,
    default: false,
  },
  scrim: {
    type: String,
    default: 'white',
  },
})
</script>

<template>
  <v-sheet
    class="d-flex flex-column"
    :class="[
      fillHeight ? 'fill-height' : '',
      flat ? 'elevation-0' : 'rounded-lg elevation-2',
    ]"
  >
    <v-overlay
      class="align-center justify-center"
      contained
      content-class="fill-width"
      :model-value="loading"
      persistent
      :scrim="scrim"
    >
      <BaseLoader :text="loadingText" />
    </v-overlay>
    <div
      v-if="$slots.header"
      class="d-flex align-center text-h6 font-weight-medium px-4 py-2"
      :class="[
        colorHeader ? 'bg-primary rounded-t-lg' : '',
      ]"
    >
      <slot name="header" />
    </div>
    <v-divider v-if="$slots.header && dividers" />

    <div
      v-if="$slots.default"
      class="d-flex flex-column flex-grow-1"
      :class="[
        center ? 'align-center justify-center' : '',
        noPadding ? 'pa-0' : 'px-4',
        !$slots.actions && !noPadding ? 'pb-4' : '',
        !$slots.header && !noPadding ? 'pt-4' : '',
      ]"
      style="overflow-x: auto"
    >
      <slot />
    </div>

    <v-divider
      v-if="$slots.actions && dividers"
      class="d-print-none"
    />
    <div
      v-if="$slots.actions"
      class="d-flex pa-2 d-print-none"
    >
      <slot name="actions" />
    </div>
  </v-sheet>
</template>
